"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetButton = void 0;
const react_1 = __importDefault(require("react"));
const CloseRounded_1 = __importDefault(require("@mui/icons-material/CloseRounded"));
const ResetButton = ({ onClick, isDisabled }) => (react_1.default.createElement("div", { className: "squiz-gb-scope" },
    react_1.default.createElement("button", { type: "button", "aria-label": `Remove selection`, title: `Remove selection`, className: "text-gray-500 hover:text-gray-800 focus:text-gray-800 w-6 h-6 disabled:text-gray-500 disabled:cursor-not-allowed", disabled: isDisabled, onClick: onClick },
        react_1.default.createElement(CloseRounded_1.default, null))));
exports.ResetButton = ResetButton;
